<template>
    <div class="lb">
        <div class="ctn1" @click="playVideo()">
            <img class="play" src="@/assets/temimg6/video_play.png" alt="" v-if="isvideo" />
            <div class="video_img">
                <img v-for="(item, i) in 4" :class="`avatar-icon avatar-icon-${item}`" :key="i"
                    src="@/assets/temimg8/human-icon.png">
                <video ref="videoRef" :src="defaultdata[0].value1" type="video/mp4" :controls="!isvideo" muted
                    :autoplay="!isvideo" loop :poster="!isvideo ? defaultdata[0].value2 : ''"></video>
            </div>
        </div>
        <div class="video-list">
            <div class="video-item" :class="{active: videoindex == i}" v-for="(item, i) in defaultdata" :key="i" @click="videoChange(i)" v-if="item && item.value1">
                <img :src="item.value2" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import * as methods from "./method.js";
export default {
    name: "template.scope85",
    props: {
        vdata: {
            type: [Array, String],
            default: () => [],
        },
        jsondata: {
            type: [Array, String],
            default: () => [],
        },
        scopedata: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            title: "scope81-新数值条形图-完成",
            timer: null,
            defaultdata: [
                {
                    value1: "http://121.4.173.197:8000/defaultimg/defaultvideo1.mp4",
                    value2: "http://121.4.173.197:8000/defaultimg/default10.png",
                }, {
                    value1: "http://121.4.173.197:8000/defaultimg/defaultvideo2.mp4",
                    value2: "http://121.4.173.197:8000/defaultimg/default10.png",
                }, {
                    value1: "http://121.4.173.197:8000/defaultimg/defaultvideo1.mp4",
                    value2: "http://121.4.173.197:8000/defaultimg/default10.png",
                }, {
                    value1: "http://121.4.173.197:8000/defaultimg/defaultvideo1.mp4",
                    value2: "http://121.4.173.197:8000/defaultimg/default10.png",
                }, {
                    value1: "http://121.4.173.197:8000/defaultimg/defaultvideo1.mp4",
                    value2: "http://121.4.173.197:8000/defaultimg/default10.png",
                },
            ],
            valueMap: [
                { name: "视频地址", key: "value1" },
                { name: "视频封面", key: "value2" },
                { name: "视频时长", key: 'value3' }
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
            isvideo: true,
            timer2: null,
            videoindex: 0
        };
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
				let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
            }
        },
        jsondata(n) {
            this.exceldata = n;
        },
        defaultdata(n) {
        },
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.timer = null;
        clearTimeout(this.timer2)
        this.timer2 = null
    },
    methods: {
        ...methods,
        playVideo(i) {
            clearTimeout(this.timer2)
            this.timer2 = null
            const video = this.$refs.videoRef;
            if (this.isvideo) {
                this.isvideo = false;
                video.play().catch((error) => {
                    console.error("视频播放出错:", error);
                })
                .then(res => {
                    let timerout = this.defaultdata[i].value3
                    this.timer2 = setTimeout(() => {
                        let vindex = i + 1
                        if (vindex >= this.defaultdata.length) {
                            vindex = 0
                        }
                        this.videoChange(vindex)
                    }, timerout * 1000);
                })
            } else {
                this.isvideo = true;
                video.pause();
            }
        },
        videoChange(i) {
            clearTimeout(this.timer2)
            this.timer2 = null
            let newurl = this.defaultdata[i]
            const video = this.$refs.videoRef
            video.src = newurl.value1
            this.videoindex = i
            if (this.isvideo) {
                this.playVideo(i)
            } else {
                let timerout = this.defaultdata[i].value3
                this.timer2 = setTimeout(() => {
                    let vindex = i + 1
                    if (vindex >= this.defaultdata.length) {
                        vindex = 0
                    }
                    this.videoChange(vindex)
                }, timerout * 1000);
            }
        },
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata;
        }
        this.setData()
        let host = window.location.host
        if (host == 'www.17886.cn') {
            let news = 'https://www.17886.cn'
            let olds = 'http://121.4.173.197:8000'
            this.defaultdata.forEach(item => {
                if (item.value1.includes(olds)) {
                    item.value1 = item.value1.replace(olds, news)
                }
                if (item.value2.includes(olds)) {
                    item.value2 = item.value2.replace(olds, news)
                }
            })
            this.defaultdata = [...this.defaultdata]
        }
        this.playVideo(0)
    },
};
</script>

<style scoped lang="scss">
.lb {
    width: 435px;
    height: 400px;
    padding: 10px 0;
    position: relative;
    overflow: hidden;

    .video-list {
        width: calc(100% - 12px);
        overflow-x: auto;
        display: flex;
        white-space: nowrap;
        column-gap: 8px;
        margin: 12px 0 0 6px;
        padding-bottom: 16px;

        &::-webkit-scrollbar {
            height: 8px;
        }

        .video-item {
            min-width: 136px;
            width: 136px;
            height: 82px;
            cursor: pointer;

            img {
                width: 100%;
                height: 100%;
            }
            &.active {
                border: 2px solid #2CA3FF;
                box-sizing: border-box;
            }
        }

        .active {
            border: 1px solid #00A6FF;
            box-sizing: border-box;
        }
    }

    .ctn1 {
        margin: 0 auto;
        width: 435px;
        height: 250px;
        box-sizing: border-box;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        .play {
            width: 79px;
            height: 79px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 5;
        }

        .video_img {
            width: 414px;
            height: 240px;
            border: 2px solid #32405e;
            padding: 2px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #000;

            video {
                width: 98%;
                height: 98%;
            }

            .avatar-icon {
                width: 18px;
                height: 18px;
                position: absolute;
                animation: linght 2s linear infinite;
            }

            @keyframes linght {
                0% {
                    opacity: 1;
                }

                50% {
                    opacity: 0.3;
                }

                100% {
                    opacity: 1;
                }
            }

            .avatar-icon-1 {
                left: -6px;
                top: -6px;
                transform: rotate(180deg);
            }

            .avatar-icon-2 {
                right: -6px;
                top: -6px;
                transform: rotate(-90deg);
            }

            .avatar-icon-3 {
                right: -6px;
                bottom: -6px;
            }

            .avatar-icon-4 {
                left: -6px;
                bottom: -6px;
                transform: rotate(90deg);
            }

            img {
                width: 98%;
                height: 98%;
            }
        }

    }
}
</style>